import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const UsageCard = ({ usageImg, usageName, usageMinPrice, usageLink }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("global");

  const handleClick = () => {
    if (usageLink.startsWith('http')) {
      // External link - open in new tab
      window.open(usageLink, '_blank');
    } else {
      // Internal link - use navigate
      navigate(usageLink);
    }
  };

  return (
    <div className={styles.usageCard} onClick={handleClick}>
      <div
        className={styles.usageCardImage}
        style={{ backgroundImage: `url(${usageImg})` }}
      />
      
      <p className={styles.usageCardName}>{usageName}</p>

      <div className={styles.usageCardActions}>
        <p className={styles.usageCardPrice}>
          {usageMinPrice}
        </p>

        <button
          className={styles.usageCardButton}
          onClick={handleClick}
        >
          → {t("buttons.viewAllSpaces")}
        </button>
      </div>
    </div>
  );
};

export default UsageCard;